import { render, staticRenderFns } from "./DashboardInsurerMessages.vue?vue&type=template&id=15111685&scoped=true"
import script from "./DashboardInsurerMessages.vue?vue&type=script&lang=js"
export * from "./DashboardInsurerMessages.vue?vue&type=script&lang=js"
import style0 from "./DashboardInsurerMessages.vue?vue&type=style&index=0&id=15111685&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15111685",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15111685')) {
      api.createRecord('15111685', component.options)
    } else {
      api.reload('15111685', component.options)
    }
    module.hot.accept("./DashboardInsurerMessages.vue?vue&type=template&id=15111685&scoped=true", function () {
      api.rerender('15111685', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/DashboardInsurerMessages.vue"
export default component.exports